import {Record} from 'immutable';
import isNil from 'lodash/isNil';
import {requiredMessage} from 'utils/const';

export const MEETING_TYPES = {
  physical: 'PhysicalLocation',
  phone: 'Phone',
  conference: 'Other',
};

const TYPE_DETAILS = {
  PhysicalLocation: 'locationDetail',
  Phone: 'phoneDetail',
  Other: 'conferenceDetail',
};

export function validate(meetingType) {
  const errors = {};

  if (!meetingType) return errors;

  const meetingTypeSelected = meetingType.meetingType;

  if (!meetingType.locationDetail && meetingTypeSelected === MEETING_TYPES.physical) {
    errors[MEETING_TYPES.physical] = requiredMessage;
  }

  if (!meetingType.phoneDetail && meetingTypeSelected === MEETING_TYPES.phone) {
    errors[MEETING_TYPES.phone] = requiredMessage;
  }

  if (!meetingType.conferenceDetail && meetingTypeSelected === MEETING_TYPES.conference) {
    errors[MEETING_TYPES.conference] = requiredMessage;
  }

  return errors;
}

export default class extends Record({
  id: null,
  meetingType: null,
  locationDetail: null,
  phoneDetail: null,
  conferenceDetail: null,
}) {
  constructor(object = {}) {
    const {meetingType, phoneDetail, conferenceDetail, locationDetail} = object;
    if (meetingType) {
      super(object);
    } else {
      // If we don't have a meeting type, try to derive it
      const meetingType = !isNil(phoneDetail)
        ? MEETING_TYPES.phone
        : !isNil(conferenceDetail)
        ? MEETING_TYPES.conference
        : !isNil(locationDetail)
        ? MEETING_TYPES.physical
        : null;

      super({
        ...object,
        meetingType,
      });
    }
  }

  setDetail(content) {
    // dont allow setting null
    content = isNil(content) ? '' : content;
    const field = TYPE_DETAILS[this.meetingType];
    return this.set(field, content);
  }

  detail() {
    const field = TYPE_DETAILS[this.meetingType];
    return field ? this.get(field) : null;
  }
}
